<template>
  <v-btn :data-cy="shareButtonDataCy" class="ml-2 d-md-none rotate-270" fab @click="shareMobile">
    <v-img width="24" height="24" contain :src="$asset('img/icons/logout.svg')" />
  </v-btn>
</template>

<script>
export default {
  name: 'ShareButton',
  props: {
    title: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    event: {
      type: String,
      required: true
    },
    shareButtonDataCy: {
      type: String,
      required: false
    }
  },
  methods: {
    shareMobile() {
      this.gtmPush({ event: this.event, 'event.detail': 'link_share' });

      const shareData = {
        title: this.title,
        text: this.text,
        url: this.url
      };
      try {
        if (this.isMobileApp && this.isFlutterReady && !this.isHu) {
          window.flutter_inappwebview.callHandler('share', shareData);
        } else {
          navigator.share(shareData);
        }
      } catch (err) {
        this.handleError({ error: err, code: '0x0000000D' });
      }
    }
  }
};
</script>
